import type { AuthUser } from '@attendance/shared';
import { api } from '../lib/api.js';

/** `POST /api/auth/view-as` — see packages/api/src/routes/viewAs.routes.ts. */
export interface ViewAsSession {
  /** The person, exactly as their own `/auth/me` answers. */
  user: AuthUser;
  /** Short, and never refreshed. Held in memory only. */
  accessToken: string;
  /** When the server stops honouring the token; the console leaves then. */
  expiresAt: string;
}

export const viewAsApi = {
  start: (userId: string) =>
    api.post<{ data: ViewAsSession }>('/auth/view-as', { userId }).then((r) => r.data),
  /** Records the end. Sent with the view-as token, before it is dropped. */
  exit: () => api.post<{ data: { ok: true } }>('/auth/view-as/exit'),
};
